module.exports = __webpack_public_path__ + "static/media/school.b140a86d.svg";